import Vue from 'vue';
import Vuex from 'vuex';

import auth from '@/store/modules/auth';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		layout: null,
		historyList: [],
		countryList: [],
		linkToEdit: null,
		lastCreatedLink: null,
		clickStats: null,
		topCountry: {
			TopCountryCountClicks: 0,
			TopCountryEstimatedName: '',
			TopCountryISOCode: '',
		},
		availableClickStatsCountries: [],
		AllTimeCountClicks: 0,
		user: null,
	},
	mutations: {
		SET_LAYOUT(state, payload) {
			state.layout = payload;
		},
		SET_HISTORY_LIST(state, historyList) {
			state.historyList = historyList;
		},
		SET_COUNTRY_LIST(state, countryList) {
			state.countryList = countryList;
		},
		SET_LINK_TO_EDIT(state, link) {
			state.linkToEdit = link;
		},
		SET_LAST_CREATED_LINK(state, link) {
			state.lastCreatedLink = link;
		},
		SET_CLICK_STATS(state, stats) {
			state.clickStats = stats;
		},
		SET_TOP_COUNTRY(state, topCountry) {
			state.topCountry = topCountry;
		},
		SET_AVAILABLE_CLICK_STATS_COUNTRIES(state, countries) {
			state.availableClickStatsCountries = countries;
		},
		SET_ALL_TIME_COUNT_CLICKS(state, count) {
			state.AllTimeCountClicks = count;
		},
		SET_USER(state, user) {
			state.user = user;
		},
	},
	actions: {
		setLayout({ commit }, layout) {
			if (!layout) {
				commit('SET_LAYOUT', 'default');
				return;
			}

			commit('SET_LAYOUT', layout);
		},

		async getCurrentUserData() {
			try {
				const response = await Vue.callAPI({
					method: 'GET',
					path: '/getprofile',
				});

				return response.data.Data;
			} catch (error) {
				Vue.notify({
					duration: 6000,
					type: 'error',
					title: '',
					text: 'oops! Something went wrong.',
				});
				return error;
			}
		},

		async fetchHistory({ commit }) {
			try {
				const response = await Vue.callAPI({
					method: 'GET',
					path: '/gethistory',
				});

				commit('SET_HISTORY_LIST', response.data.Data.Links);
			} catch (error) {
				Vue.notify({
					duration: 6000,
					type: 'error',
					title: '',
					text: 'oops! Something went wrong.',
				});
			}
		},

		async createLink(context, link) {
			try {
				const response = await Vue.callAPI({
					method: 'POST',
					path: '/createlink',
					data: {
						defaultURL: link,
					},
				});

				context.commit('SET_LAST_CREATED_LINK', response.data.Data);
				context.dispatch('fetchHistory');

				return response.data.Data;
			} catch (error) {
				Vue.notify({
					duration: 6000,
					type: 'error',
					text: 'oops! Something went wrong.',
				});
				return error;
			}
		},

		async saveLink(context, link) {
			try {
				const response = await Vue.callAPI({
					method: 'POST',
					path: '/savelink',
					data: link,
				});

				context.dispatch('fetchHistory');
				return response.data.Data;
			} catch (error) {
				Vue.notify({
					duration: 6000,
					type: 'error',
					text: 'oops! Something went wrong.',
				});
				return error;
			}
		},

		async deleteLink({ commit, dispatch }, linkId) {
			try {
				const response = await Vue.callAPI({
					method: 'DELETE',
					path: `/deletelink/${linkId}`,
				});

				Vue.notify({
					duration: 6000,
					type: 'info',
					text: 'You deleted the shortlink',
				});

				commit('SET_LINK_TO_EDIT', null);
				dispatch('fetchHistory');

				return response.data.Data;
			} catch (error) {
				Vue.notify({
					duration: 6000,
					type: 'error',
					text: 'oops! Something went wrong.',
				});
				return error;
			}
		},

		async fetchCountries(context) {
			try {
				const response = await Vue.callAPI({
					method: 'GET',
					path: '/getcountries',
				});

				context.commit('SET_COUNTRY_LIST', response.data.Data);
			} catch (error) {
				Vue.notify({
					duration: 6000,
					type: 'error',
					text: 'oops! Something went wrong.',
				});
			}
		},

		setLinkToEdit(context, link) {
			context.commit('SET_LINK_TO_EDIT', link);
		},

		async fetchClickStats({ commit }) {
			try {
				const response = await Vue.callAPI({
					method: 'GET',
					path: '/getclickstats',
				});

				commit('SET_TOP_COUNTRY', {
					TopCountryCountClicks: response.data.Data.TopCountryCountClicks,
					TopCountryEstimatedName: response.data.Data.TopCountryEstimatedName,
					TopCountryISOCode: response.data.Data.TopCountryISOCode,
				});

				commit('SET_ALL_TIME_COUNT_CLICKS', response.data.Data.AllTimeCountClicks);

				commit('SET_CLICK_STATS', {
					country: {
						EstimatedName: response.data.Data.TopCountryEstimatedName,
						ISOCode: response.data.Data.TopCountryISOCode,
					},
					XAxisValues: response.data.Data.XAxisValues,
					YAxisMaxValue: response.data.Data.YAxisMaxValue,
					YAxisMinValue: response.data.Data.YAxisMinValue,
				});

				commit('SET_AVAILABLE_CLICK_STATS_COUNTRIES', response.data.Data.AvailableCountries);
			} catch (error) {
				Vue.notify({
					duration: 6000,
					type: 'error',
					title: '',
					text: 'oops! Something went wrong.',
				});
			}
		},

		async fetchClickStatsByCountry({ commit }, country) {
			try {
				const response = await Vue.callAPI({
					method: 'GET',
					path: `/getclickstats/${country.ISOCode}`,
				});

				commit('SET_CLICK_STATS', {
					country,
					XAxisValues: response.data.Data.XAxisValues,
					YAxisMaxValue: response.data.Data.YAxisMaxValue,
					YAxisMinValue: response.data.Data.YAxisMinValue,
				});
			} catch (error) {
				Vue.notify({
					duration: 6000,
					type: 'error',
					title: '',
					text: 'oops! Something went wrong.',
				});
			}
		},

		async getInviteCode() {
			const response = await Vue.callAPI({
				method: 'GET',
				path: '/getinvitationcode',
			});

			return response.data.Data;
		},

		async fetchUser({ commit }) {
			const response = await Vue.callAPI({
				method: 'GET',
				path: '/getcurrentuserdata',
			});

			const user = response.data.Data;

			commit('SET_USER', user);

			this._vm.$intercom.boot({
				user_id: user.Id,
				name: user.FullName,
				email: user.EMailAddress,
			});

			return user;
		},
	},
	getters: {
		historyList: (state) => state.historyList,
		countryList: (state) => state.countryList,
		linkToEdit: (state) => state.linkToEdit,
		isLastCreatedLinkToEdit: (state) => {
			if (state.linkToEdit && state.lastCreatedLink) {
				return state.linkToEdit.Id === state.lastCreatedLink.Id;
			}

			return false;
		},
		clickStats: (state) => state.clickStats,
		topCountry: (state) => state.topCountry,
		availableClickStatsCountries: (state) => state.availableClickStatsCountries,
		user: (state) => state.user,
		layout: (state) => (state.layout ? `layout-${state.layout}` : ''),
		allTimeCountClicks: (state) => state.AllTimeCountClicks,
	},
	modules: {
		auth,
	},
});
